import { hasText } from 'shared/lib/common-util'

export type ActiveBorderTransportMeans = {
  typeOfIdentification: string
  estimatedDateAndTimeOfArrival: string
  estimatedDateAndTimeOfDeparture: string
  actualDateAndTimeOfDeparture: string
}

export type PreviousDocument = {
  documentType?: string | null
  procedureType: string | null
  referenceNumber: string
  deleted?: boolean
}

export type TransportDocument = {
  documentType: string
  referenceNumber: string
  deleted?: boolean
}

export type CountryOfRoutingOfConsignment = {
  country: string | null
  sequenceNumber: number
  deleted?: boolean
}

export type Place = {
  country?: string
  unLocode?: string
}

export type CustomsOfficeOfTransitDeclared = {
  entryIndicator: string | null
  reEntryIndicator: string | null
  referenceNumber: string
  arrivalDateAndTime: string
  deleted?: boolean
}

export type CustomsOfficeOfExitForTransitDeclared = {
  referenceNumber: string
}

export type HouseConsignment = {
  referenceNumberUCR: string
  grossMass: number
  countryOfDispatch: string
  placeOfAcceptance: Place
  placeOfDelivery: Place
  countriesOfRouting: CountryOfRoutingOfConsignment[]
  previousDocument: PreviousDocument[]
  transportDocument: TransportDocument[]
  deleted?: boolean
}

export type Packaging = {
  typeOfPackages: string
  numberOfPackages: number
  shippingMarks: string
  deleted: boolean
}

export type ConsignmentItem = {
  declarationType?: string | null
  countryOfDispatch?: string
  goodsMeasureGrossMass?: number
  goodsMeasureNetMass?: number
  previousDocument?: PreviousDocument[]
  packaging?: Packaging[]
  deleted?: boolean
}

export type AdditionalReference = {
  type: string
  referenceNumber: string
}

export type Seal = {
  identifier: string
  deleted?: boolean
}

export type TransportEquipment = {
  sequenceNumber: number
  containerIdentificationNumber: string
  seals: Seal[]
  deleted?: boolean
}

export type DepartureTransportMeans = {
  sequenceNumber: number
  typeOfIdentification: string
  deleted: boolean
}

export type Authorisation = {
  type?: string
  deleted?: boolean
}

export type AdditionalInformation = {
  code: string
  deleted: boolean
}

export type Address = {
  country: string
  city: string
  addressLine?: string
  postcode: string
  street?: string
  streetNumber?: string
}

export type PostcodeAddress = {
  houseNumber: string
  postcode: string
  country: string
}

export type LocationOfGoods = {
  typeOfLocation?: string
  authorisationNumber: string
  qualifierOfIdentification: string
  address?: Address
  postcodeAddress?: PostcodeAddress
}

export type ContactPerson = {
  name: string
  telephone: string
  email: string
}

export type Consignee = {
  identificationNumber: string
  name: string
  typeOfPerson: string
  address?: Address
  contactPerson: ContactPerson
}

export type Consignor = {
  identificationNumber: string
  name: string
  typeOfPerson: string
  address?: Address
  contactPerson: ContactPerson
}

export type Carrier = {
  identificationNumber: string
  name: string
  address?: Address
  contactPerson: ContactPerson
}

export type Seller = {
  identificationNumber: string
  name: string
  typeOfPerson: string
  address?: Address
  contactPerson: ContactPerson
}

export type Buyer = {
  identificationNumber: string
  name: string
  typeOfPerson: string
  address?: Address
  contactPerson: ContactPerson
}

export const isAddressPresent = (address: Address | undefined) => hasText(address?.city)
  || hasText(address?.country)
  || hasText(address?.addressLine)
  || hasText(address?.postcode)

export const isConsigneePresent = (
  consignee: Consignee | undefined,
) => !!consignee?.identificationNumber
  || !!consignee?.name
  || isAddressPresent(consignee?.address)

export const isConsignorPresent = (
  consignor: Consignor | undefined,
) => !!consignor?.identificationNumber
  || !!consignor?.name
  || isAddressPresent(consignor?.address)

export const isSellerPresent = (
  seller: Seller | undefined,
) => !!seller?.identificationNumber
  || !!seller?.name
  || isAddressPresent(seller?.address)

export const isBuyerPresent = (
  buyer: Buyer | undefined,
) => !!buyer?.identificationNumber
  || !!buyer?.name
  || isAddressPresent(buyer?.address)

